import { recordLinkFieldLabel } from '@/components/domain/record-link/fields';
import { useI18n } from '@/composables/i18n';

const MAX_NAMED_CLUBS = 2;

/** the head lines shared by the suggestion and the group card */
export function useCardText() {
    const { i18n } = useI18n();

    const distinctNames = (names: string[]): string => names
        .filter((name, index) => names.indexOf(name) === index)
        .join(' / ');

    function recordsLine(clubs: string[]): string {
        const named = clubs.slice(0, MAX_NAMED_CLUBS).join(', ');
        const hidden = clubs.length - MAX_NAMED_CLUBS;
        const suffix = hidden > 0 ? ` ${i18n.t('+{count} weitere', { count: hidden })}` : '';

        return `${i18n.t('{count} Datensätze', { count: clubs.length })} · ${named}${suffix}`;
    }

    function differencesSummary(divergentFields: string[]): string | null {
        if (divergentFields.length === 0) {
            return null;
        }
        const labels = divergentFields.map((field) => i18n.t(recordLinkFieldLabel(field))).join(', ');

        return `${labels} ${divergentFields.length === 1 ? i18n.t('weicht ab') : i18n.t('weichen ab')}`;
    }

    return { distinctNames, recordsLine, differencesSummary };
}
